import styles from "@/components/loading-popup.module.css";
import clsx from "clsx";
import { JSX } from "react";

function LoadingPopup(): JSX.Element {
	return (
		<div className={clsx(styles["container"], "z-index", "zoom-in")}>
			<div className={styles["loader"]}></div>
		</div>
	);
}

export default LoadingPopup;
